import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import MagnifiquePopup from "../components/MagnifiquePopup";

function encodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
        return String.fromCharCode('0x' + p1);
    }));
}

function PopupLink({ url, children }) {
    const [appearPopup, setAppearPopup] = useState(false);

    // Use convert the url passed in, into a 
    const id = encodeUnicode(url);

    const continueCallback = () => {
        window.location.href = url;
    };

    const cancelCallback = () => {
        setAppearPopup(false);
    };

    return (
        <>
            <a href={url} onClick={(event) => {event.preventDefault(); setAppearPopup(true);}}>
                {children}
            </a>
            <MagnifiquePopup
                id={`leavingACEConfirmation-${id}`}
                trigger={appearPopup}
                setTrigger={setAppearPopup}
                continueCallback={continueCallback}
                cancelCallback={cancelCallback}
                header={<FormattedMessage id="message.leavingACE.confirmation" />}
                body={<FormattedMessage id="message.leavingACE.explanation" />}
            />
        </>
    );
}

export default PopupLink;